import { ColumnsType } from 'antd/lib/table';
import { TFunction } from 'i18next';
import { ITaskCategory } from '../Task/slice/types';
import {
  ACCOUNTING_METHODS_MAP,
  EMPLOYEE_ACCOUNTING_METHODS_MAP,
  IEmployee,
  IImplement,
  IMPLEMENT_ACCOUNTING_METHODS_MAP,
  ITransport,
} from './types';

export const getTransportColumns = (t: TFunction) => {
  const columns: ColumnsType<ITransport> = [
    {
      title: t('Transport.Model', 'Model'),
      dataIndex: 'model',
      key: 'model',
      sorter: true,
    },
    {
      title: t('Transport.LicensePlate', 'License plate'),
      dataIndex: 'licensePlate',
      key: 'licensePlate',
      sorter: true,
    },
    {
      title: t('Transport.Type', 'Type'),
      dataIndex: ['type', 'name'],
      key: 'type',
      // sorter: true,
    },
    {
      title: t('Transport.GpsId', 'GPS ID'),
      dataIndex: ['gpsVehicle', 'gpsId'],
      key: 'gpsId',
      // sorter: true,
    },
    {
      title: t('Transport.Year', 'Year of production'),
      dataIndex: 'year',
      key: 'year',
      sorter: true,
    },
    {
      title: t('Transport.MotoHours', 'Motohours'),
      dataIndex: 'motoHours',
      key: 'motoHours',
      sorter: true,
    },
    {
      title: t('Transport.Ownership', 'Ownership'),
      dataIndex: ['company', 'name'],
      key: 'company',
      // sorter: true,
    },
    {
      title: t(
        'Transport.MainCategoryWithouImplement',
        'Main category of tasks to be performed without the implement',
      ),
      dataIndex: 'defaultTaskCategory',
      key: 'defaultTaskCategory',
      sorter: false,
      render: (taskCategory: ITaskCategory | null) => taskCategory?.name,
    },
    {
      title: t(
        'Transport.CategoriesWithoutImplement',
        'Categories of tasks to be performed without the implement',
      ),
      dataIndex: 'taskCategories',
      key: 'taskCategories',
      sorter: false,
      render: (taskCategories: ITaskCategory[] | null) =>
        taskCategories?.map(taskCategory => taskCategory.name).join(', '),
    },

    {
      title: t('Transport.MotoHourCostPrice', 'Motohour cost price'),
      dataIndex: 'motoHourCostPrice',
      key: 'motoHourCostPrice',
      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === ACCOUNTING_METHODS_MAP.motoHours,
        )?.costPrice,
    },
    {
      title: t('Transport.MotoHourSellPrice', 'Motohour sell price'),
      dataIndex: 'motoHourSellPrice',
      key: 'motoHourSellPrice',
      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === ACCOUNTING_METHODS_MAP.motoHours,
        )?.sellPrice,
    },

    {
      title: t('Transport.HaCostPrice', 'Ha cost price'),
      dataIndex: 'haCostPrice',
      key: 'haCostPrice',

      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === ACCOUNTING_METHODS_MAP.ha,
        )?.costPrice,
    },
    {
      title: t('Transport.HaSellPrice', 'Ha sell price'),
      dataIndex: 'haSellPrice',
      key: 'haSellPrice',
      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === ACCOUNTING_METHODS_MAP.ha,
        )?.sellPrice,
    },

    {
      title: t('Transport.KmCostPrice', 'Km cost price'),
      dataIndex: 'kmCostPrice',
      key: 'kmCostPrice',
      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === ACCOUNTING_METHODS_MAP.km,
        )?.costPrice,
    },
    {
      title: t('Transport.KmSellPrice', 'Km sell price'),
      dataIndex: 'kmSellPrice',
      key: 'kmSellPrice',
      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === ACCOUNTING_METHODS_MAP.km,
        )?.sellPrice,
    },
  ];

  return columns;
};

export const getEditTransportFormInitialValues = (transport: ITransport) => {
  const {
    type,
    model,
    licensePlate,
    company,
    gpsVehicle,
    accountingMethods,
    motoHours,
    defaultTaskCategory,
    taskCategories,
    year,
    width,
  } = transport;

  const values = {
    typeId: type.id,
    model,
    licensePlate,
    companyId: company.id,
    gpsVehicleId: gpsVehicle?.id,
    width,
    year,
    motoHours,
    defaultTaskCategoryId: defaultTaskCategory?.id,

    taskCategoryIds: taskCategories.map(taskCategory => taskCategory.id),
    accountingMethods: accountingMethods.map(method => method.id),

    motoHourCostPrice: accountingMethods?.find(
      method => method.id === ACCOUNTING_METHODS_MAP.motoHours,
    )?.costPrice,
    motoHourSellPrice: accountingMethods?.find(
      method => method.id === ACCOUNTING_METHODS_MAP.motoHours,
    )?.sellPrice,

    haCostPrice: accountingMethods?.find(
      method => method.id === ACCOUNTING_METHODS_MAP.ha,
    )?.costPrice,
    haSellPrice: accountingMethods?.find(
      method => method.id === ACCOUNTING_METHODS_MAP.ha,
    )?.sellPrice,

    kmCostPrice: accountingMethods?.find(
      method => method.id === ACCOUNTING_METHODS_MAP.km,
    )?.costPrice,

    kmSellPrice: accountingMethods?.find(
      method => method.id === ACCOUNTING_METHODS_MAP.km,
    )?.sellPrice,
  };
  return values;
};

export const getEditImplementFormInitialValues = (implement: IImplement) => {
  const {
    type,
    model,
    company,
    gpsImplement,
    accountingMethods,
    width,
    defaultTaskCategory,
    taskCategories,
    year,
  } = implement;

  const values = {
    typeId: type.id,
    model: model,
    companyId: company.id,
    gpsImplementId: gpsImplement?.id,
    year,
    width,
    defaultTaskCategoryId: defaultTaskCategory?.id,
    taskCategoryIds: taskCategories.map(taskCategory => taskCategory.id),
    accountingMethods: accountingMethods.map(method => method.id),

    motoHourCostPrice: accountingMethods?.find(
      method => method.id === IMPLEMENT_ACCOUNTING_METHODS_MAP.motoHours,
    )?.costPrice,
    motoHourSellPrice: accountingMethods?.find(
      method => method.id === IMPLEMENT_ACCOUNTING_METHODS_MAP.motoHours,
    )?.sellPrice,

    haCostPrice: accountingMethods?.find(
      method => method.id === IMPLEMENT_ACCOUNTING_METHODS_MAP.ha,
    )?.costPrice,
    haSellPrice: accountingMethods?.find(
      method => method.id === IMPLEMENT_ACCOUNTING_METHODS_MAP.ha,
    )?.sellPrice,
  };
  return values;
};

export const getImplementColumns = (t: TFunction) => {
  const columns: ColumnsType<IImplement> = [
    {
      title: t('Transport.Model', 'Model'),
      dataIndex: 'model',
      key: 'model',
      sorter: true,
    },
    {
      title: t('Transport.Type', 'Type'),
      dataIndex: ['type', 'name'],
      key: 'type',
      // sorter: true,
    },
    {
      title: 'Bluetooth ID',
      dataIndex: ['gpsImplement', 'name'],
      key: 'gpsId',
      // sorter: true,
    },
    {
      title: t('Transport.Year', 'Year of production'),
      dataIndex: 'year',
      key: 'year',
      sorter: true,
    },
    {
      title: t('Implement.ImpementWidth', 'Implement width (m)'),
      dataIndex: 'width',
      key: 'width',
      sorter: true,
    },
    {
      title: t('Transport.Ownership', 'Ownership'),
      dataIndex: ['company', 'name'],
      key: 'company',
      // sorter: true,
    },

    {
      title: t('Implement.MainPerformingTask', 'Main performing task'),
      dataIndex: 'defaultTaskCategory',
      key: 'defaultTaskCategory',
      sorter: false,
      render: (taskCategory?: ITaskCategory) => taskCategory?.name,
    },
    {
      title: t('Implement.PerformingTask', 'Performing task'),
      dataIndex: 'taskCategories',
      key: 'taskCategories',
      sorter: false,
      render: (taskCategories: ITaskCategory[] | null) =>
        taskCategories?.map(taskCategory => taskCategory.name).join(', '),
    },

    {
      title: t('Transport.MotoHourCostPrice', 'Motohour cost price'),
      dataIndex: 'motoHourCostPrice',
      key: 'motoHourCostPrice',
      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === IMPLEMENT_ACCOUNTING_METHODS_MAP.motoHours,
        )?.costPrice,
    },
    {
      title: t('Transport.MotoHourSellPrice', 'Motohour sell price'),
      dataIndex: 'motoHourSellPrice',
      key: 'motoHourSellPrice',
      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === IMPLEMENT_ACCOUNTING_METHODS_MAP.motoHours,
        )?.sellPrice,
    },

    {
      title: t('Transport.HaCostPrice', 'Ha cost price'),
      dataIndex: 'haCostPrice',
      key: 'haCostPrice',

      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === IMPLEMENT_ACCOUNTING_METHODS_MAP.ha,
        )?.costPrice,
    },
    {
      title: t('Transport.HaSellPrice', 'Ha sell price'),
      dataIndex: 'haSellPrice',
      key: 'haSellPrice',
      render: (_: unknown, transport) =>
        transport.accountingMethods?.find(
          method => method.id === IMPLEMENT_ACCOUNTING_METHODS_MAP.ha,
        )?.sellPrice,
    },
  ];

  return columns;
};

export const getEditEmployeeFormInitialValues = (employee: IEmployee) => {
  const {
    firstName,
    birthYear,
    phoneNumber,
    company,
    salary,
    gpsEmployee,
    accountingMethods,
  } = employee;

  const values = {
    firstName,
    birthYear,
    phoneNumber,

    companyId: company.id,
    gpsEmployeeId: gpsEmployee?.id,
    salary,

    accountingMethods: accountingMethods.map(method => method.id),

    hourCostPrice: accountingMethods?.find(
      method => method.id === EMPLOYEE_ACCOUNTING_METHODS_MAP.hours,
    )?.costPrice,
    hourSellPrice: accountingMethods?.find(
      method => method.id === EMPLOYEE_ACCOUNTING_METHODS_MAP.hours,
    )?.sellPrice,

    haCostPrice: accountingMethods?.find(
      method => method.id === EMPLOYEE_ACCOUNTING_METHODS_MAP.ha,
    )?.costPrice,
    haSellPrice: accountingMethods?.find(
      method => method.id === EMPLOYEE_ACCOUNTING_METHODS_MAP.ha,
    )?.sellPrice,
  };
  return values;
};

export const getEmployeeColumns = (t: TFunction) => {
  const columns: ColumnsType<IEmployee> = [
    {
      title: t('Employee.Name', 'Name Surname'),
      dataIndex: 'firstName',
      key: 'name',
      sorter: true,
    },
    {
      title: t('Employee.Year', 'Year of birth'),
      dataIndex: 'birthYear',
      key: 'birthYear',
      sorter: true,
    },
    {
      title: 'SLIM ID',
      dataIndex: ['gpsEmployee', 'name'],
      key: 'slimId',
      sorter: true,
    },
    {
      title: t('Employee.Workplace', 'Workplace'),
      dataIndex: ['company', 'name'],
      key: 'company',
      sorter: true,
    },

    {
      title: t('Employee.PhoneNumber', 'Phone number'),
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      sorter: true,
    },
    {
      title: t('Employee.BasicSalary', 'Basic salary'),
      dataIndex: 'salary',
      key: 'salary',
      sorter: true,
    },

    {
      title: t('Employee.HourCostPrice', 'Hour cost price'),
      dataIndex: 'hourCostPrice',
      key: 'hourCostPrice',
      render: (_: unknown, employee) =>
        employee.accountingMethods?.find(
          method => method.id === EMPLOYEE_ACCOUNTING_METHODS_MAP.hours,
        )?.costPrice,
    },
    {
      title: t('Employee.HourSellPrice', 'Hour sell price'),
      dataIndex: 'hourSellPrice',
      key: 'hourSellPrice',
      render: (_: unknown, employee) =>
        employee.accountingMethods?.find(
          method => method.id === EMPLOYEE_ACCOUNTING_METHODS_MAP.hours,
        )?.sellPrice,
    },

    {
      title: t('Transport.HaCostPrice', 'Ha cost price'),
      dataIndex: 'haCostPrice',
      key: 'haCostPrice',

      render: (_: unknown, employee) =>
        employee.accountingMethods?.find(
          method => method.id === EMPLOYEE_ACCOUNTING_METHODS_MAP.ha,
        )?.costPrice,
    },
    {
      title: t('Transport.HaSellPrice', 'Ha sell price'),
      dataIndex: 'haSellPrice',
      key: 'haSellPrice',
      render: (_: unknown, employee) =>
        employee.accountingMethods?.find(
          method => method.id === EMPLOYEE_ACCOUNTING_METHODS_MAP.ha,
        )?.sellPrice,
    },
  ];

  return columns;
};
